import { omit, reduce, some, isEmpty, isNull, isString, isUndefined, pick } from 'lodash';
import { parse } from 'query-string';
const QUERY_PARAMS = {
  'accounts': ['cohorts', 'groups', 'page', 'partners', 'sort', 'q', 'order', 'archived'],
  'accountPlayers': ['accounts', 'cohorts', 'end', 'groups', 'page', 'partners', 'sort', 'start', 'q', 'order', 'archived', 'unread'],
  'dashboard': ['ages', 'cohorts', 'groups', 'partners'],
  'groupCohorts': ['groups', 'withcohorts', 'withages', 'start', 'end'],
  'groupCohortsByOrganizationType': ['withages', 'start', 'end', 'organizationTypes'],
  'surveys': ['asq', 'recent', 'cohorts', 'groups', 'order', 'player', 'page', 'sort', 'sortCleared', 'teachers', 'concern', 'start', 'end'],
};

const objectToQueryString = (obj) => {
  let qs = reduce(obj, (result, value, key) => {
    return (!isNull(value) && !isUndefined(value) && !(isString(value) && isEmpty(value))) ? (result += key + '=' + value + '&') : result;
  }, '').slice(0, -1);
  return qs;
}

export const isQueryChanged = (state, params, type) =>
  some(QUERY_PARAMS[type], (v, _i) => state[v] !== params[v])

export const getQueryFromParams = (params) => {
  let toOmit = ['periods', 'tz', 'init'];
  if (params.page === 1) toOmit.push('page');
  if (params.recent === true) toOmit.push('recent');
  if (params.archived === false) toOmit.push('archived');
  if (params.unread === false) toOmit.push('unread');
  if (params.sort === 'id') toOmit.push('sort');
  if (!params.sortCleared) toOmit.push('sortCleared');
  if (params.withcohorts) toOmit.push('withcohorts');
  if (params.withages) toOmit.push('withages');
  if (params.order === 'asc') toOmit.push('order');
  return isEmpty(toOmit) ? objectToQueryString(params) : objectToQueryString(omit(params, toOmit));
}

export const getParamsFromQuery = (query) => parse(query);

export const getQueryFromState = (state, type = 'surveys') =>
  getQueryFromParams(pick(state, QUERY_PARAMS[type]))
